import { createFileRoute } from "@tanstack/react-router";

import { useAuth } from "@/application/contexts/AuthContext";
import { usePermissions } from "@/application/hooks/usePermissions";
import { PowerBiExportPage } from "@/presentation/pages/PowerBiExportPage";
import { UnauthorizedPage } from "@/presentation/pages/UnauthorizedPage";

export const Route = createFileRoute("/admin/export-xlsx")({
  component: function PowerBiExportRoute() {
    const { isLoading } = useAuth();
    const { admin } = usePermissions();

    if (isLoading) {
      return null;
    }

    if (!admin.canExportPowerBi) {
      return <UnauthorizedPage />;
    }

    return <PowerBiExportPage />;
  },
});